<template>
  <div id="common-footer" class="common-footer">
		<small>Copyright NHK（Japan Broadcasting Corporation）All rights reserved.</small>
  </div>
</template>

<script>
/* eslint-enable */
export default {
  name: 'CommonFooter',
  data() {
    return {
    }
  },
  mounted(){ // ページが読み込まれたらする処理
  },
}
/* eslint-enable */
</script>
